const courseCommerce = {
  en: {
    common: {
      backToCourse: 'Back to course',
      parent: 'Course workspace',
      clear: 'Clear',
      clearFilters: 'Clear filters',
    },
    enrollments: {
      title: 'Students',
      subtitle: 'Students enrolled in this course, with their status and progress.',
      countEnrolled: '{count} enrolled',
      addStudentCta: 'Add student',
      addStudentFormTitle: 'Add student',
      phonePlaceholder: '+998 90 123 45 67',
      cancelButton: 'Cancel',
      addStudentSubmit: 'Add',
      addingButton: 'Adding...',
      searchPlaceholder: 'Search by name, email or phone...',
      statusFilterAriaLabel: 'Filter by status',
      allStatuses: 'All statuses',
      statusActive: 'Active',
      statusCompleted: 'Completed',
      statusCancelled: 'Cancelled',
      tableStudent: 'Student',
      tableStatus: 'Status',
      tableEnrolled: 'Enrolled',
      tableProgress: 'Progress',
      loading: 'Loading enrollments...',
      emptyTitle: 'No students yet',
      emptyDescription: 'Add a student and they will show up here.',
      filteredEmptyTitle: 'No students found',
      filteredEmptyDescription: 'Try another search or status.',
      errorFailedToLoad: 'Failed to load enrollments',
      accessDenied: "You don't have access to view these enrollments.",
      errorFailedToEnroll: 'Failed to add the student',
      grantHint: 'Enter the person\'s phone number and name. If they have no account yet, one is created — the course is waiting when they sign in to the platform with this number.',
      phoneLabel: 'Phone number',
      firstNameLabel: 'First name',
      lastNameLabel: 'Last name',
      tariffLabel: 'Tariff',
      tariffNone: 'No tariff (course price)',
      noteLabel: 'Note',
      notePlaceholder: 'e.g. paid in cash at the office',
      errorPhoneAndName: 'Enter a phone number and a first name.',
      grantCreated: '{name} was added to the course. An account was created for {phone} — they sign in with this number.',
      grantDone: '{name} was added to the course.',
      grantAlreadyEnrolled: '{name} is already enrolled in this course.',
    },
    revenue: {
      loading: 'Loading revenue data...',
      title: 'Revenue & payments',
      subtitle: 'Earnings, payment methods, and transaction history for this course.',
      errorFailedToLoad: 'Failed to load revenue data',
      accessDenied: "You don't have access to view this revenue data.",
      summaryAdminOnly: 'Revenue totals and charts are available to account admins. The course payment history is below.',
      kpiTotalRevenue: 'Total revenue',
      kpiPaymentsMeta: '{count} payments',
      kpiAveragePayment: 'Average payment',
      kpiPerTransaction: 'Per transaction',
      kpiPending: 'Pending payments',
      kpiNoBaseline: 'No previous month to compare',
      kpiVsLastMonth: 'vs last month',
      kpiMonthlyGrowth: 'Monthly growth',
      chartRevenueTrend: 'Revenue trend',
      chartNoRevenueData: 'No revenue data yet',
      chartPaymentMethods: 'Payment methods',
      chartNoPaymentData: 'No payment data yet',
      chartRevenueSeriesName: 'Revenue',
      paymentHistoryTitle: 'Payment history',
      startDateAriaLabel: 'Start date',
      endDateAriaLabel: 'End date',
      methodFilterAriaLabel: 'Filter by method',
      statusFilterAriaLabel: 'Filter by status',
      allMethods: 'All methods',
      methodPaycom: 'Payme',
      methodClick: 'Click',
      allStatuses: 'All statuses',
      statusCompleted: 'Paid',
      statusPending: 'Pending',
      statusProcessing: 'Processing',
      statusFailed: 'Failed',
      statusCancelled: 'Cancelled',
      clearButton: 'Clear',
      filterDates: 'Date range',
      filterMethod: 'Payment method',
      emptyTitle: 'No payments yet',
      emptyDescription: 'Payments for this course will appear here.',
      filteredEmptyTitle: 'No payments found',
      filteredEmptyDescription: 'Try other dates or filters.',
      chartRevenueDesc: 'By month, in UZS',
      tableStudent: 'Student',
      tableAmount: 'Amount',
      tableMethod: 'Method',
      tableDate: 'Date',
      tableStatus: 'Status',
    },
  },
  ru: {
    common: {
      backToCourse: 'Назад к курсу',
      parent: 'Управление курсом',
      clear: 'Очистить',
      clearFilters: 'Сбросить фильтры',
    },
    enrollments: {
      title: 'Студенты',
      subtitle: 'Студенты, записанные на курс: их статус и прогресс.',
      countEnrolled: '{count} записано',
      addStudentCta: 'Добавить студента',
      addStudentFormTitle: 'Добавить студента',
      phonePlaceholder: '+998 90 123 45 67',
      cancelButton: 'Отмена',
      addStudentSubmit: 'Добавить',
      addingButton: 'Добавление...',
      searchPlaceholder: 'Поиск по имени, email или телефону...',
      statusFilterAriaLabel: 'Фильтр по статусу',
      allStatuses: 'Все статусы',
      statusActive: 'Активен',
      statusCompleted: 'Завершён',
      statusCancelled: 'Отменён',
      tableStudent: 'Студент',
      tableStatus: 'Статус',
      tableEnrolled: 'Дата записи',
      tableProgress: 'Прогресс',
      loading: 'Загрузка записей...',
      emptyTitle: 'Пока нет студентов',
      emptyDescription: 'Добавьте студента, и он появится здесь.',
      filteredEmptyTitle: 'Студенты не найдены',
      filteredEmptyDescription: 'Попробуйте другой запрос или статус.',
      errorFailedToLoad: 'Не удалось загрузить записи',
      accessDenied: 'У вас нет доступа для просмотра этих записей.',
      errorFailedToEnroll: 'Не удалось добавить студента',
      grantHint: 'Укажите номер телефона и имя. Если аккаунта ещё нет, он будет создан — курс будет ждать человека, когда он войдёт на платформу с этим номером.',
      phoneLabel: 'Номер телефона',
      firstNameLabel: 'Имя',
      lastNameLabel: 'Фамилия',
      tariffLabel: 'Тариф',
      tariffNone: 'Без тарифа (цена курса)',
      noteLabel: 'Примечание',
      notePlaceholder: 'например, оплата наличными в офисе',
      errorPhoneAndName: 'Укажите номер телефона и имя.',
      grantCreated: '{name} добавлен на курс. Для номера {phone} создан аккаунт — вход по этому номеру.',
      grantDone: '{name} добавлен на курс.',
      grantAlreadyEnrolled: 'У {name} уже есть доступ к этому курсу.',
    },
    revenue: {
      loading: 'Загрузка данных о доходах...',
      title: 'Доходы и платежи',
      subtitle: 'Доходы, способы оплаты и история транзакций по этому курсу.',
      errorFailedToLoad: 'Не удалось загрузить данные о доходах',
      accessDenied: 'У вас нет доступа для просмотра этих данных о доходах.',
      summaryAdminOnly: 'Сводка по доходам и графики доступны администраторам аккаунта. Ниже — история платежей по курсу.',
      kpiTotalRevenue: 'Общий доход',
      kpiPaymentsMeta: '{count} платежей',
      kpiAveragePayment: 'Средний платёж',
      kpiPerTransaction: 'За транзакцию',
      kpiPending: 'Ожидающие платежи',
      kpiNoBaseline: 'Нет данных за прошлый месяц',
      kpiVsLastMonth: 'по сравнению с прошлым месяцем',
      kpiMonthlyGrowth: 'Рост за месяц',
      chartRevenueTrend: 'Динамика доходов',
      chartNoRevenueData: 'Данных о доходах пока нет',
      chartPaymentMethods: 'Способы оплаты',
      chartNoPaymentData: 'Данных о платежах пока нет',
      chartRevenueSeriesName: 'Доход',
      paymentHistoryTitle: 'История платежей',
      startDateAriaLabel: 'Начальная дата',
      endDateAriaLabel: 'Конечная дата',
      methodFilterAriaLabel: 'Фильтр по способу оплаты',
      statusFilterAriaLabel: 'Фильтр по статусу',
      allMethods: 'Все способы',
      methodPaycom: 'Payme',
      methodClick: 'Click',
      allStatuses: 'Все статусы',
      statusCompleted: 'Оплачен',
      statusPending: 'В ожидании',
      statusProcessing: 'В обработке',
      statusFailed: 'Ошибка',
      statusCancelled: 'Отменён',
      clearButton: 'Очистить',
      filterDates: 'Период',
      filterMethod: 'Способ оплаты',
      emptyTitle: 'Платежей пока нет',
      emptyDescription: 'Платежи по этому курсу появятся здесь.',
      filteredEmptyTitle: 'Платежи не найдены',
      filteredEmptyDescription: 'Попробуйте другие даты или фильтры.',
      chartRevenueDesc: 'По месяцам, в сумах',
      tableStudent: 'Студент',
      tableAmount: 'Сумма',
      tableMethod: 'Способ',
      tableDate: 'Дата',
      tableStatus: 'Статус',
    },
  },
  uz: {
    common: {
      backToCourse: 'Kursga qaytish',
      parent: 'Kurs boshqaruvi',
      clear: 'Tozalash',
      clearFilters: 'Filtrlarni tozalash',
    },
    enrollments: {
      title: "O'quvchilar",
      subtitle: "Kursga yozilgan o'quvchilar, ularning holati va progressi.",
      countEnrolled: "{count} ta o'quvchi",
      phonePlaceholder: '+998 90 123 45 67',
      cancelButton: 'Bekor qilish',
      searchPlaceholder: "Ism, email yoki telefon bo'yicha qidirish...",
      statusFilterAriaLabel: 'Holat bo\'yicha filtr',
      allStatuses: 'Barcha holatlar',
      statusActive: 'Faol',
      statusCompleted: 'Tugallangan',
      statusCancelled: 'Bekor qilingan',
      tableStudent: "O'quvchi",
      tableStatus: 'Holat',
      tableEnrolled: 'Yozilgan sana',
      tableProgress: 'Progress',
      loading: 'Yozilishlar yuklanmoqda...',
      emptyTitle: "Hozircha o'quvchilar yo'q",
      emptyDescription: "O'quvchi qo'shing — u shu yerda ko'rinadi.",
      filteredEmptyTitle: "O'quvchilar topilmadi",
      filteredEmptyDescription: "Boshqa so'rov yoki holatni sinab ko'ring.",
      errorFailedToLoad: 'Yozilishlarni yuklab bo\'lmadi',
      accessDenied: "Sizda bu yozilishlarni ko'rish uchun ruxsat yo'q.",
      errorFailedToEnroll: "O'quvchini yozib bo'lmadi",
      addStudentCta: "O'quvchi qo'shish",
      addStudentFormTitle: "O'quvchi qo'shish",
      addStudentSubmit: "Qo'shish",
      addingButton: "Qo'shilmoqda...",
      grantHint: 'Telefon raqami va ismni kiriting. Hisobi bo\'lmasa, yaratiladi — u platformaga shu raqam bilan kirganda kurs tayyor turadi.',
      phoneLabel: 'Telefon raqami',
      firstNameLabel: 'Ism',
      lastNameLabel: 'Familiya',
      tariffLabel: 'Tarif',
      tariffNone: 'Tarifsiz (kurs narxi)',
      noteLabel: 'Izoh',
      notePlaceholder: 'masalan, ofisda naqd to\'lagan',
      errorPhoneAndName: 'Telefon raqami va ismni kiriting.',
      grantCreated: "{name} kursga qo'shildi. {phone} raqami uchun hisob yaratildi — shu raqam bilan kiradi.",
      grantDone: "{name} kursga qo'shildi.",
      grantAlreadyEnrolled: '{name} bu kursga allaqachon yozilgan.',
    },
    revenue: {
      loading: "Daromad ma'lumotlari yuklanmoqda...",
      title: "Daromad va to'lovlar",
      subtitle: "Ushbu kurs uchun daromad, to'lov usullari va tranzaksiyalar tarixi.",
      errorFailedToLoad: "Daromad ma'lumotlarini yuklab bo'lmadi",
      accessDenied: "Sizda bu daromad ma'lumotlarini ko'rish uchun ruxsat yo'q.",
      summaryAdminOnly: "Daromad xulosasi va grafiklar akkaunt administratorlariga ko'rinadi. Quyida kurs bo'yicha to'lovlar tarixi.",
      kpiTotalRevenue: 'Umumiy daromad',
      kpiPaymentsMeta: "{count} ta to'lov",
      kpiAveragePayment: "O'rtacha to'lov",
      kpiPerTransaction: 'Har bir tranzaksiya uchun',
      kpiPending: "Kutilayotgan to'lovlar",
      kpiNoBaseline: "Oldingi oy ma'lumoti yo'q",
      kpiVsLastMonth: "o'tgan oyga nisbatan",
      kpiMonthlyGrowth: "Oylik o'sish",
      chartRevenueTrend: 'Daromad dinamikasi',
      chartNoRevenueData: "Hozircha daromad ma'lumotlari yo'q",
      chartPaymentMethods: "To'lov usullari",
      chartNoPaymentData: "Hozircha to'lov ma'lumotlari yo'q",
      chartRevenueSeriesName: 'Daromad',
      paymentHistoryTitle: "To'lovlar tarixi",
      startDateAriaLabel: 'Boshlanish sanasi',
      endDateAriaLabel: 'Tugash sanasi',
      methodFilterAriaLabel: "To'lov usuli bo'yicha filtr",
      statusFilterAriaLabel: 'Holat bo\'yicha filtr',
      allMethods: 'Barcha usullar',
      methodPaycom: 'Payme',
      methodClick: 'Click',
      allStatuses: 'Barcha holatlar',
      statusCompleted: "To'langan",
      statusPending: 'Kutilmoqda',
      statusProcessing: 'Jarayonda',
      statusFailed: 'Muvaffaqiyatsiz',
      statusCancelled: 'Bekor qilingan',
      clearButton: 'Tozalash',
      filterDates: "Sana oralig'i",
      filterMethod: "To'lov usuli",
      emptyTitle: "Hozircha to'lovlar yo'q",
      emptyDescription: "Shu kurs bo'yicha to'lovlar bu yerda ko'rinadi.",
      filteredEmptyTitle: "To'lovlar topilmadi",
      filteredEmptyDescription: "Boshqa sana yoki filtrlarni sinab ko'ring.",
      chartRevenueDesc: "Oylar bo'yicha, so'm",
      tableStudent: "O'quvchi",
      tableAmount: 'Summa',
      tableMethod: 'Usul',
      tableDate: 'Sana',
      tableStatus: 'Holat',
    },
  },
};

export default courseCommerce;
